const ClientTypes = {
  WEB: 100,
  SPA: 200,
  MOBILE: 300,
  SERVER: 400
}

export const ClientTypeTitle = (type = '') => {
    switch (type) {
      case ClientTypes.SPA:
        return "SPA"
      case ClientTypes.WEB:
        return "Web"
      case ClientTypes.MOBILE:
        return "Mobile"
      case ClientTypes.SERVER:
        return "Server"
      default:
        return "-"
    }
  }

  export default ClientTypes